<!--
 * @Author: mazhigang
 * @Date: 2023-09-10 15:27:44
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-10-28 16:52:57
-->
<template>
  <div style="background: #FAFCFF;overflow-x: scroll;">
    <div class="pageTop">
      <div class="topBox">
        <pageTop :color="'#000'"></pageTop>
      </div>
    </div>
    <div style="padding-top: 65px;box-sizing: border-box;">
      <div class="topBanner">
        <img src="../../../static/userBanner.png" alt="" style="width: 100%;" />
        <div style="position: absolute;top: 50px;left: 28%;">
          <div style="font-size: 28px;font-weight: bold;">
            保安来了APP产品介绍
          </div>
          <div class="solid"></div>
          <div style="font-size: 16px;">数字化新平台</div>
        </div>
      </div>
      <div>
        <!-- <div class="boxTitle">
          <img
            src="../../../static/titleIcon.png"
            alt=""
            style="width: 31px;height: 25px;z-index: 1;margin-right: 10px;margin-top: 4px;"
          />
          <div>咖德安保App产品介绍</div>
        </div> -->
        <div class="swiperBox">
          <div style="overflow: hidden;">
            <div style="display: flex;align-items: center;margin-top: 88px;">
              <img
                src="../../../static/oldLogo.png"
                alt=""
                style="width: 76px;height: 76px;margin-right: 16px;"
              />
              <div>
                <div style="font-size: 22px;font-weight: bold;">保安来了</div>
                <div style="font-size: 16px;color: #545D80;">
                  数字化新平台
                </div>
              </div>
            </div>
            <div style="width: 575px;margin-left: 103px;margin-top: 24px;">
              <div class="accordion">
                <div
                  v-for="(item, index) in list"
                  :key="index"
                  :class="[
                    'accordion-item',
                    activeIndex === index ? 'activeBg' : ''
                  ]"
                  @click="toggle(index)"
                >
                  <div class="title">
                    <img
                      v-if="index != activeIndex"
                      src="../../../static/rightFlo.png"
                      alt=""
                      style="width:8px;height: 8px;margin-right: 14px;"
                    />
                    <img
                      v-if="index == activeIndex"
                      src="../../../static/downFlo.png"
                      alt=""
                      style="width:8px;height: 8px;margin-right: 14px;"
                    />
                    {{ item.title }}
                  </div>
                  <div class="content" :class="{ open: activeIndex === index }">
                    {{ item.info }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 50px;margin-right: 110px;position: relative;">
            <div class="carousel" style="width: 254px;">
              <!-- 图片轮播区域 -->
              <div class="carousel-inner" :style="carouselInnerStyle">
                <div
                  v-for="(image, index) in images"
                  :key="index"
                  class="carousel-item"
                  :style="itemStyle(index)"
                >
                  <img
                    :src="image"
                    alt="Carousel Image"
                    style="width: 100%; height: 543px; object-fit: cover;"
                  />
                </div>
              </div>
              <!-- 进度条指示器 -->
            </div>
            <div class="indicators" v-if="images.length > 1">
              <div
                v-for="(image, index) in images"
                :key="index"
                class="indicator"
              >
                <div style="width: 50px;margin-right: 10px;">
                  <el-progress
                    :show-text="false"
                    :percentage="imageProgress[index]"
                    :color="'rgba(16, 95, 255, 1)'"
                  ></el-progress>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pagebottom></pagebottom>
    <pageleft></pageleft>
  </div>
</template>
<script>
import pageTop from "../../components/pageTitle.vue";
import pageleft from "../../components/leftCode.vue";
import pagebottom from "../../components/pagebottom.vue";
export default {
  components: {
    pageTop,
    pageleft,
    pagebottom
  },
  data() {
    return {
      activeIndex: 0,
      list: [
        {
          title: "工作台",
          info:
            "首页总入口，展示员工及项目信息，提供考勤打卡、事件上报两大核心功能快捷入口，底部切换工作台 / 个人中心。",
          img: ["../../../static/newBanner1.png"]
        },
        {
          title: "事件上报",
          info:
            "安保现场问题报备页，支持上传图文视频 + 文字描述，填写后提交上报，快速记录现场隐患、突发情况。",
          img: ["../../../static/newBanner2.png"]
        },
        {
          title: "考勤打卡",
          info:
            "定点打卡页面，自动校验考勤定位，一键点击上班打卡完成外勤人员考勤签到。",
          img: ["../../../static/newBanner3.png"]
        },
        {
          title: "通知中心",
          info:
            "统一接收工作推送，展示政策、物业调度通知，支持查看 PDF、图片类附件文件",
          img: ["../../../static/newBanner4.png"]
        }
      ],
      currentIndex: 0,
      images: [],
      intervalId: null,
      slideDuration: 5000, // 每张图片展示的时间，单位为毫秒
      imageProgress: []
    };
  },
  mounted() {
    this.images = this.list[this.activeIndex].img;
    this.resetImageProgress();
    this.startAutoPlay();
  },
  beforeDestroy() {
    this.stopAutoPlay();
  },
  computed: {
    carouselInnerStyle() {
      return {
        transform: `translateX(-${this.currentIndex * 100}%)`
      };
    }
  },
  methods: {
    resetImageProgress() {
      this.imageProgress = new Array(this.images.length).fill(0);
    },
    toggle(index) {
      this.stopAutoPlay(); // 停止旧定时器
      this.resetImageProgress();
      this.activeIndex = index;
      this.images = this.list[this.activeIndex].img || [];
      this.currentIndex = 0;

      this.$nextTick(() => {
        if (this.images.length > 0) {
          this.startAutoPlay();
        }
      });
    },
    itemStyle(index) {
      const offset = index - this.currentIndex;
      return {
        transition: `transform 0.5s ease`,
        transform: `translateX(${offset * 100}%)`
      };
    },
    startAutoPlay() {
      this.stopAutoPlay();

      // 每张图的播放周期独立控制
      const playCurrent = () => {
        let elapsed = 0;
        const step = 10; // 每10ms更新一次
        const total = this.slideDuration;

        // 重置当前图进度为 0
        this.$set(this.imageProgress, this.currentIndex, 0);

        const progressTimer = setInterval(() => {
          elapsed += step;
          const percent = Math.min(100, (elapsed / total) * 100);
          this.$set(this.imageProgress, this.currentIndex, percent);
          if (elapsed >= total) {
            clearInterval(progressTimer);
            this.resetImageProgress();
            this.next(); // 切换下一张
          }
        }, step);

        this.intervalId = progressTimer; // 用于清理
      };

      // 立即开始第一张
      playCurrent();

      // 监听 currentIndex 变化（通过 next 触发下一张）
      // 注意：我们不再用 setInterval(next, duration)，而是靠 progress 完成后手动调 next
    },

    stopAutoPlay() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    next() {
      if (this.images.length <= 1) return;

      this.currentIndex = (this.currentIndex + 1) % this.images.length;

      // 自动开始下一张的进度条
      this.$nextTick(() => {
        this.startAutoPlay(); // 重新启动（会清理上一个 timer 并启动新的）
      });
    },
    goToSlide(index) {
      this.currentIndex = index;
    }
  }
};
</script>
<style scoped>
@media (max-width: 1920px) {
  .swiperBox {
    transform: scale(0.9);
  }
}
.topBox {
  width: 100%;
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgba(155, 155, 155, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
.topBanner {
  width: 100%;
  position: relative;
}
.solid {
  width: 72px;
  height: 6px;
  background: linear-gradient(270deg, rgba(238, 238, 238, 0) 0%, #4b74fe 100%);
  border-radius: 3px;
  margin: 14px 0 14px 0;
}
.boxTitle {
  font-size: 25px;
  font-weight: bold;
  color: #00122c;
  line-height: 29px;
  display: flex;
  align-content: center;
  justify-content: center;
}
.boxTitle img {
  z-index: -1;
}
.swiperBox {
  width: 1200px;
  margin: 16px auto;
  box-sizing: border-box;
  height: 680px;
  background-image: url("../../../static/swiperBg.png");
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
}

.accordion {
  width: 100%;
  max-width: 600px;
  margin: 20px auto;
}

.accordion-item {
  cursor: pointer;
}
.activeBg {
  background: linear-gradient(
    180deg,
    #ffffff 0%,
    rgba(255, 255, 255, 0.21) 100%
  );
  border-radius: 8px;
}

/* 标题样式 */
.title {
  display: flex;
  align-items: center;
  padding: 16px 12px;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

/* 内容区域 - 关键动画 */
.content {
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  padding: 0 12px;
  color: #555;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 1.6;
  transition: max-height 0.4s ease, opacity 0.3s ease, padding 0.3s ease;
}

.content.open {
  max-height: 200px; /* 必须 ≥ 最大内容高度 */
  opacity: 1;
  padding: 0px 12px 16px 32px;
}
.carousel {
  position: relative;
  overflow-x: hidden;
}

.carousel-inner {
  height: 100%;
  display: flex;
  transition: transform 0.5s ease;
}

.carousel-item {
  min-width: 100%;
  height: 100%;
}

.indicators {
  display: flex;
  justify-content: center;
}
.infoBox {
  margin-top: 24px;
  background-image: url("../../../static/userModelBg.png");
  background-size: 100% 100%;
  padding-top: 26px;
  box-sizing: border-box;
}
.infoBox1 {
  margin-top: 24px;
  padding-top: 26px;
  box-sizing: border-box;
  background: #fafcff;
}
.boxContent {
  width: 1200px;
  margin: 24px auto 0;
  padding-bottom: 24px;
  box-sizing: border-box;
}
.TitleBox {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 274px;
  box-sizing: border-box;
}
.titleItem {
  width: 145px;
  height: 39px;
  background: #e1e8ff;
  border-radius: 7px;
  text-align: center;
  line-height: 40px;
  color: #105fff;
  font-size: 12px;
  font-weight: 500;
}
.itemBox {
  width: 100%;
  margin-top: 24px;
}
.infoItem {
  display: flex;
  align-items: center;
  padding: 20px 30px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(181, 181, 181, 0.5);
  border-radius: 12px;
  margin-bottom: 12px;
}
.infoItem img {
  width: 62px;
  height: 72px;
  margin-right: 20px;
}
.title1 {
  font-size: 16px;
  color: #000;
  font-weight: 600;
}
.info1 {
  font-size: 14px;
  color: #363b4d;
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/view/askri/askri.vue